module.exports = __webpack_public_path__ + "img/fiu.b6185f57.gif";